/**
 * i18n-registry.ts — Singleton accessor for I18nService.
 *
 * Stesso schema di `services/data-registry.ts`: AppShell chiama setI18n() una
 * volta dopo aver costruito il servizio, e chi non è un componente usa
 * getI18n().
 *
 * Serve a `lesson-builder-service.ts`, che è un servizio globale e non riceve
 * il contesto dei componenti: prima di questo registro le sue etichette erano
 * scritte in italiano dentro il codice, in un file INVARIANTE — cioè identico
 * in tutti i tool. Il risultato era un golden inglese che diceva «Aggiungi alla
 * lezione».
 */

import type { I18nService } from './I18nService';

let instance: I18nService | null = null;

export function setI18n(service: I18nService): void {
  instance = service;
}

export function getI18n(): I18nService {
  if (!instance) {
    throw new Error('[i18n-registry] getI18n() called before setI18n()');
  }
  return instance;
}

/** true se il registro è pronto: per chi deve degradare invece di lanciare. */
export function hasI18n(): boolean {
  return instance !== null;
}
